import { TweenMax, Power0 } from 'gsap';

export default {
	beforeRouteLeave(to, from, next) {
		TweenMax.to(this.$el, 0.2, {
			opacity: 0,
			delay: 0,
			ease: Power0.easeIn,
    });

    setTimeout(() => {
			window.scrollTop = 0;
			next();
    }, 500);
  },
};



// WEBPACK FOOTER //
// ./src/mixins/Transition.js